import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';

export const commonNameRule = computedLocale(() => ({
  type: 'string',
  required: true,
  message: i18n.t('Name is required'),
  transform: name => name?.toString().trim()
}));

export const commonNumberRule = computedLocale(() => ({
  type: 'number',
  message: i18n.t('Must be a number')
}));

export const commonVolumeNameRule = computedLocale(() => ({
  required: true,
  message: i18n.t('Specify a volume name'),
  transform: item => item?.toString().trim()
}));

export const commonVolumeSizeRule = computedLocale(() => ({
  required: true,
  message: i18n.t('Specify a volume size')
}));

export const positiveRule = computedLocale(() => ({
  type: 'integer',
  min: 0,
  message: i18n.t('Limit value cannot be less than 0')
}));

export const common2to64Rule = computedLocale(() => ({
  min: 2,
  max: 64,
  message: i18n.t('Must be from {from} to {to} characters long', { from: 2, to: 64 }),
}));

export const common2to255Rule = computedLocale(() => ({
  min: 2,
  max: 255,
  message: i18n.t('Must be from {from} to {to} characters long', { from: 2, to: 255 })
}));

export const commonNameTo64Rule = computedLocale(() => ({
  max: 64,
  message: i18n.t('Name must be up to 64 characters long')
}));
